import { createSlice } from '@reduxjs/toolkit'

export const drgValidationSlice = createSlice({
    name: 'drgValidation',
    initialState: {
        result: null,
    },
    reducers: {
        setDrgValidation: (state, action) => {
            state.result = action.payload;
        },
        clearDrgValidation: (state) => {
            state.result = null;
        }
    },
})

export const { setDrgValidation, clearDrgValidation } = drgValidationSlice.actions;

export const getDrgValidation = (state) => state.drgValidation.result;

export default drgValidationSlice.reducer